import { flex, stack } from "@styled-system/patterns";

export const selectedItemsContainerClass = stack({
	gap: "8",
});

export const selectedItemsListClass = stack({
	gap: "4",
	border: "1px solid",
	borderColor: "shade.20",
	padding: "4",
});

export const selectedItemClass = flex({
	justifyContent: "space-between",
	alignItems: "center",
});

export const selectedItemContentClass = stack({
	gap: "4",
});

export const selectedItemFieldsClass = flex({
	gap: "4",
});

export const selectProductOrDiscountCodeContainerClass = stack({
	gap: "4",
	marginTop: "12",
	padding: "12",
	border: "1px solid",
	borderColor: "shade.20",
	borderRadius: "4",
	backgroundColor: "shade.10",
});

export const selectProductOrDiscountCodeHeaderClass = flex({
	justifyContent: "space-between",
	alignItems: "center",
});

export const totalPriceContainerClass = stack({
	gap: "4",
});
